import { t } from '@lingui/core/macro';
import { PurchasingSupplierContactDTO, SupplierContactDTO } from '@luminovo/api-contracts';
import { isPresent } from '@luminovo/commons';
import { FieldSelect, FieldSelectProps } from '@luminovo/design-system';
import type { JSX } from 'react';

export interface FieldSupplierContactProps<
    T extends SupplierContactDTO | PurchasingSupplierContactDTO,
> extends FieldSelectProps<T> {
    onValueChange?: (value: T | null) => void;
}

export function FieldSupplierContact<T extends SupplierContactDTO | PurchasingSupplierContactDTO>({
    onChange,
    onValueChange,
    ...props
}: FieldSupplierContactProps<T>): JSX.Element {
    return (
        <FieldSelect
            getOptionLabel={(supplierContact) =>
                isPresent(supplierContact)
                    ? `${supplierContact.first_name} ${supplierContact.last_name} (${supplierContact.email})`
                    : t`No recipient selected`
            }
            isOptionEqualToValue={(opt, value) => opt.id === value.id}
            disableClearable
            onChange={(value) => {
                onChange(value);
                onValueChange?.(value);
            }}
            {...props}
        />
    );
}
